import React from "react";
import {
	TextField,
	Container,
	Box,
	Typography, InputLabel, Select, MenuItem, FormControl,
} from "@mui/material";
import {IJobDefinition, InputType} from "../../models/JobDefinition";
import {TagsCard} from "../common/Tags";
import {ITag} from "../../models/Tag";

interface IJobDefinitionFormProps {
	jobDefinition: IJobDefinition;
	setJobDefinition: (jobDefinition: IJobDefinition) => void;
}

export const JobDefinitionForm: React.FC<IJobDefinitionFormProps> = (props) => {
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		props.setJobDefinition({
			...props.jobDefinition,
			[event.target.name]: event.target.value,
		});
	};
	
	const onChangeTags =(tags: ITag[]) => {
		props.setJobDefinition({
			...props.jobDefinition,
			tags : tags,
		});
	};
	return (
		<Container maxWidth="sm">
			<Box sx={{ padding: 3 }}>
				<Typography variant="h4" component="h1" align="center" gutterBottom>
					Job Definition
				</Typography>
				<form>
					<TextField
						fullWidth
						label="ID"
						name="jobDefinition"
						value={props.jobDefinition.id}
						onChange={handleChange}
						margin="normal"
						type="number"
						required
						disabled
					/>
					<TextField
						fullWidth
						label="Name"
						name="name"
						value={props.jobDefinition.name}
						onChange={handleChange}
						margin="normal"
						required
					/>
					<TextField
						fullWidth
						label="Description"
						name="description"
						value={props.jobDefinition.description}
						onChange={handleChange}
						margin="normal"
						required
					/>
					<FormControl fullWidth margin="normal" required>
						<InputLabel htmlFor="inputType">Input Type</InputLabel>
						<Select
							label="InputType"
							name="inputType"
							value={props.jobDefinition.inputType}
							onChange={handleChange as any}
						>
							{Object.values(InputType).map((inputType) => (
								<MenuItem key={inputType} value={inputType}>
									{inputType}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<TagsCard tags={props.jobDefinition.tags} onChangeTags={onChangeTags}/>
				</form>
			</Box>
		</Container>
	);
};
